import React from 'react';
import { BoneIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type FinalCTAProps = {
  guaranteeEnabled: boolean;
};
export function FinalCTA({
  guaranteeEnabled
}: FinalCTAProps) {
  return <section className="bg-navy px-4 py-6 text-center md:px-12 md:py-8" data-id="element-56" data-mp="83vwxc2bzm21">
      <h2 className="font-heading text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-gold md:text-[29px]" data-id="element-57" data-mp="m3wyktqf6xik">
        One final question
      </h2>
      <div className="mx-auto mt-2 max-w-[580px] space-y-1.5 text-[14px] leading-[1.45] text-white md:text-[15px]" data-id="element-58" data-mp="vui4714ih2az">
        <p data-id="element-59" data-mp="qvexlc8vuo0w">
          How often does a complex case send you to different references, documents, diagnostic tables, and tools?
        </p>
        <p className="text-onNavyMuted" data-id="element-60" data-mp="14vpryp9eikqt">
          You can keep using separate resources for each task — or bring them together in one organized orthopedic
          clinical reference system.
        </p>
      </div>
      <p className="mt-2 font-heading text-[13px] font-extrabold uppercase text-gold md:text-[14px]" data-id="element-61" data-mp="2c710zvzbwltt">
        Assess. Analyze. Prioritize. Plan.
      </p>

      <div className="mx-auto mt-3 max-w-[240px]" data-id="element-62" data-mp="2m1sw8t5fuwlf">
        <ProductImage data-id="element-63" data-mp="2r1xgmu9gwbgx" />
      </div>

      <h3 className="mx-auto mt-2 max-w-[600px] font-heading text-[22px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-white md:text-[28px]" data-id="element-64" data-mp="2r2768gqlogm3">
        <BoneIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-aqua" strokeWidth={2.5} aria-hidden data-id="element-65" data-mp="2v1oc3b9xvfrs" />
        Complete Orthopedic &amp; Trauma Toolkit™
      </h3>
      <p className="mx-auto mt-1 max-w-[600px] font-heading text-[11px] font-bold uppercase leading-tight text-white md:text-[12px]" data-id="element-66" data-mp="34tu2igkjlp4v">
        The complete clinical resource collection for orthopedic surgeons &amp; trauma specialists
      </p>
      <p className="mx-auto mt-1 max-w-[600px] text-[13px] leading-[1.35] text-onNavyMuted md:text-[14px]" data-id="element-67" data-mp="3istthuvj2g47">
        Advanced Clinical Assessment • Differential Diagnosis • Complex Trauma • Orthopedic Conditions • Treatment
        Planning • Complications &amp; Follow-Up
      </p>
      <p className="mt-1.5 font-heading text-[13px] font-extrabold uppercase text-aqua md:text-[14px]" data-id="element-68" data-mp="1enfi68090hy7">
        6 Advanced Clinical Volumes + 5 FREE Professional Bonuses
      </p>
      <p className="mt-3 font-heading text-[13px] font-extrabold uppercase leading-tight text-white md:text-[14px]" data-id="element-69" data-mp="1nonfonuxxer8">
        Get the complete collection today for only
      </p>
      <p className="mt-1 font-heading text-[42px] font-extrabold leading-none tracking-[-1px] text-gold md:text-[50px]" data-id="element-70" data-mp="1xeyk0bijdpyn">
        {formatPrice(PRODUCT_PRICE)} <span className="text-[18px] tracking-normal text-white md:text-[20px]" data-id="element-71" data-mp="27dxrhqrkffk2">USD</span>
      </p>
      <div className="mt-3" data-id="element-72" data-mp="h1i20h9ccopf">
        <CtaButton mode="checkout" data-id="element-73" data-mp="h0qbvlyijj6j">Get instant access</CtaButton>
      </div>
      <p className="mt-2 text-[12px] font-semibold text-onNavyMuted md:text-[13px]" data-id="element-74" data-mp="d06cscudq5hr">
        Instant Digital Access{guaranteeEnabled && ' • 7-Day Money-Back Guarantee'}
      </p>
      <p className="mx-auto mt-1.5 max-w-[440px] font-heading text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-75" data-mp="2yc6foncpdyt">
        {guaranteeEnabled && <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-aqua" aria-hidden data-id="element-76" data-mp="3pb15qnnqjv94" />}
        6 volumes + 5 FREE professional bonuses
      </p>
    </section>;
}